import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface BaseErrorProps {
  icon: ReactNode;
  title: string;
  desc: string;
  className?: string;
}

const BaseError = ({ icon, title, desc, className }: BaseErrorProps) => {
  return (
    <section
      className={twMerge(
        'bg-[#F0F0F9] flex flex-col items-center justify-center gap-4 text-center text-[#29296B] fill-[#29296B] rounded-md px-4 py-20',
        className
      )}
    >
      <span className="size-8" data-testid="icon">
        {icon}
      </span>
      <div className="flex flex-col gap-2">
        <h6 className="font-medium">{title}</h6>
        <p className="text-sm text-balance">{desc}</p>
      </div>
    </section>
  );
};

export default BaseError;
